export default function (...args)
{
	return {

		events: ['change'],

		getValue(default_value = document.querySelector(this.selector + ' [selected]')?.value ?? -1, _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		checkValue(value = this.getValue())
		{
			return value != -1;
		},

		isEmpty(value = this.getValue())
		{
			return value == -1;
		},

		refresh()
		{
			let node = document.querySelector(this.selector);
			if (!node)
				return;
			let value = this.getValue();
			let option = node.querySelector(`OPTION[value="${value}"]`);
			node.selectedIndex = (option ? option.index : -1);
		},

		handleEvents(ev)
		{
			this.setValue(ev.target.value);
			this.refresh();
			this.checkErrorState();
		}

	};
}

